module.exports = __webpack_public_path__ + "static/media/3_EN.d3801dbb.mp3";